import columns from '../../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
    NonZeroNumberColumn,
    NonZeroPercentageColumn,
    ExternalDespatchLinkColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new ExternalDespatchLinkColumn(new TextColumn('Despatch ID', 'despatchId').withWidth(255)),
        new TextColumn('Origin IMPC', 'originImpc'),
        new TextColumn('Destination IMPC', 'destinationImpc'),
        new TextColumn('Mail category', 'mailCategory'),
        new TextColumn('Mail subclass', 'mailSubclass'),
        new DateTimeColumn('Despatch closed', 'closeDateTime'),
      ],
    },
    {
      Header: 'Receptacles',
      columns: [
        new NonZeroNumberColumn('PREDES', 'receptacles.predes'),
        new NonZeroNumberColumn('RESDES', 'receptacles.resdes'),
        new NonZeroPercentageColumn('%', 'receptacles.rcptPct'),
      ],
    },
    {
      Header: '',
      columns: [
        new NonZeroNumberColumn('Items preadvised', 'itemsPreadvised'),
        new NonZeroNumberColumn('PREDES messages', 'predesMessages'),
      ],
    },
  ];
};
